/* ==========================================================================================
   Commercial Equipment Online 2026 · ce-header.js · STAGE 3 (09-10-2026): Tommy's pick, look C2.
   sections/ce-announcement.liquid, sections/ce-header.liquid, snippets/ce-nav-tree.liquid (generated),
   snippets/ce-badge-family.liquid. Ported from the approved comps (design/comps/header-looks: looks_common.py JS,
   looks_build.py C_JS + A_JS).
   1. Bar: one message at a time, they swap every few seconds (no arrows, no progress line, no pause button); a message
      past its "show until" day is removed; reduced motion = the first message, still.
   2. Header: --ce-header-h on :root, --ceh-bottom (the nav row's bottom edge on screen: panels and the dimmed page
      start there); sticks; hides while scrolling DOWN, comes back on the way UP (never while a menu, the search or
      the phone menu is open); the nav row always fits one line (padding gives first, then the text size, never a link).
   3. Mega panels: hover with intent (a short pause before opening, a longer one before closing; moving to another
      item swaps at once), click (All categories, the hidden toggles), keyboard (Tab walks into an open panel, ArrowDown
      opens and moves in, Esc closes and returns), aria-expanded kept true. Photos load the first time a panel opens.
      FIT (Tommy's rule: no scroll bar, nothing off screen, no cut-off names): each panel sizes its photos to the
      window (big menus pick the best of several grids, the widest range as a big hero tile; small menus show every
      photo; short windows drop the counts, then the brand row - never a category).
      The group list in a big menu is a tab list: pointing at a group (or arrow keys) shows its photos.
   4. The deal card: one of the promo collections' biggest savings per page load, moved into whichever panel opens.
   5. Search: "Search" + a product word that rolls by while the box is empty.
   6. Quote: the quote app's own count (its "View Quote (N)" tab, else its saved list) on the header's Quote button;
      with products in the quote, the button opens the app's quote window.
   7. Help menu: the AI assistant first. Click / Enter opens, Esc / a click outside closes.
   8. Phones: the menu drawer (focus kept inside, Esc closes, page scroll locked, body.ce-drawer-open); a category
      opens its level (groups + photo tiles) - BUILT here from that category's mega panel the first time (the same
      tree, sent once); the chips under the search open the drawer at their category.
   9. The logo entrance (first page of a visit) + the hover replay; the family heart badge plays once after the logo.
   ========================================================================================== */
(() => {
  'use strict';
  const W = window, D = document, H = D.documentElement;
  if (W.CEHeader) { W.CEHeader.init(D); return; }
  const mq = (q) => W.matchMedia(q);
  const reduce = mq('(prefers-reduced-motion: reduce)');
  const desk = mq('(min-width: 1100px)');
  const each = (root, sel, fn) => { if (root.matches && root.matches(sel)) fn(root); root.querySelectorAll(sel).forEach(fn); };
  const today = (() => { const d = new Date(); return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate(); })();
  const dropExpired = (root) => root.querySelectorAll('[data-until]').forEach((m) => { if (+m.dataset.until && +m.dataset.until < today) m.remove(); });
  const wake = (el) => { if (el) el.querySelectorAll('img[data-src]').forEach((im) => { im.src = im.dataset.src; im.removeAttribute('data-src'); }); };
  const px = (v) => Math.round(v) + 'px';

  /* ---------- 1. the announcement bar ---------- */
  const bindBar = (bar) => {
    if (bar.ceBound) return;
    bar.ceBound = 1;
    dropExpired(bar);
    const msgs = [...bar.querySelectorAll('[data-ceb-msg]')];
    if (!msgs.length) { bar.hidden = true; return; }
    let i = Math.max(0, msgs.findIndex((m) => m.classList.contains('ceb-on')));
    msgs.forEach((m, n) => m.classList.toggle('ceb-on', n === i));
    if (msgs.length < 2) { bar.classList.add('ceb--one'); return; }
    const speed = Math.max(3, +bar.dataset.speed || 5) * 1000;
    let timer = 0, held = false;
    msgs.forEach((m) => {
      const words = m.querySelector('.ceb__link') || m;
      words.addEventListener('pointerenter', () => { held = true; });
      words.addEventListener('pointerleave', () => { held = false; });
    });
    const show = (n) => {
      const a = msgs[i];
      a.classList.remove('ceb-on'); a.classList.add('ceb-off');
      setTimeout(() => a.classList.remove('ceb-off'), 600);
      i = n;
      msgs[i].classList.remove('ceb-off'); msgs[i].classList.add('ceb-on');
    };
    const step = () => { if (D.hidden || held || bar.contains(D.activeElement)) return; show((i + 1) % msgs.length); };
    const decide = () => {
      clearInterval(timer);
      if (reduce.matches) { msgs.forEach((m, n) => { m.classList.toggle('ceb-on', n === 0); m.classList.remove('ceb-off'); }); i = 0; return; }
      timer = setInterval(step, speed);
    };
    decide();
    if (reduce.addEventListener) reduce.addEventListener('change', decide);
    bar.ceShow = (el) => { const n = msgs.indexOf(el); if (n >= 0 && n !== i) show(n); };
    // a message reached with Tab comes into view (the rotation pauses while the bar has focus, so it stays shown)
    bar.addEventListener('focusin', (e) => { const m = e.target.closest('[data-ceb-msg]'); if (m) bar.ceShow(m); });
  };

  /* ---------- 3. panel fitting (the comps' fitters, measured on the real page) ---------- */
  // how far the panel's CONTENT runs past the bottom of the window (+12px air); the panel itself never scrolls. Its top
  // is the nav row's bottom edge (measured there, so the opening slide-down never fools the sum)
  const over = (p) => {
    const nav = p.closest('.ceh-nav');
    const top = nav ? nav.getBoundingClientRect().bottom : p.getBoundingClientRect().top;
    return top + p.scrollHeight - W.innerHeight + 12;
  };
  const setRail = (p, rh, rp) => { p.style.setProperty('--rh', rh + 'px'); p.style.setProperty('--rp', rp + 'px'); };
  // how far the navy group list ITSELF runs past the window (its own height, not stretched to the photos beside it).
  // Tommy 10-10 follow-up: the list used to shrink whenever the PANEL was too tall - also when the photos were the tall
  // part, which a slimmer list (beside them) cannot fix - so its size changed with the group picked, and on a short
  // window (1366x657) the group buttons slid under a resting pointer and the next group opened. Now the list's size
  // depends only on the list and the window: the same for every group.
  const railOver = (p) => {
    const rail = p.querySelector('.ceh-rail');
    if (!rail) return over(p);
    const nav = p.closest('.ceh-nav');
    const top = nav ? nav.getBoundingClientRect().bottom : p.getBoundingClientRect().top;
    rail.style.alignSelf = 'start';
    const h = rail.getBoundingClientRect().height;
    rail.style.alignSelf = '';
    return top + h - W.innerHeight + 12;
  };
  // a name is "cut off" when a word runs past its tile, or when it needs more than two lines
  const spills = (scope, sel) => [...scope.querySelectorAll(sel)].some((e) => {
    if (!e.offsetParent) return false;
    if (e.scrollWidth > e.clientWidth + 1) return true;
    const lh = parseFloat(getComputedStyle(e).lineHeight) || 20;
    return e.getBoundingClientRect().height > lh * 2 + 2;
  });
  // Tommy 10-10 ("can't you make the 2 more categories ... in the 2 blank image spaces?"): a photo grid never shows a
  // blank slot. When a group's rows come up short, one tile in each short row takes two columns - the rows and tiles
  // are chosen so those slots go to the widest products (data-ar = the product's shape in its photo, measured by the
  // menu builder), whose photo then fills the wider box (ce-header.css 17). Returns the slots that still cannot be
  // filled (a group one column wide), which the fitters score as blanks.
  const setWide = (tiles, cols, rows) => {
    tiles.forEach((t) => t.classList.remove('is-wide'));
    const holes = cols * rows - tiles.length;
    if (holes <= 0) return 0;
    if (cols < 2 || holes > rows) return holes;
    const ar = (t) => +t.dataset.ar || 1;
    let best = null;
    const pick = (short) => {
      const wide = [];
      let sum = 0;
      for (let r = 0, i = 0; r < rows; r++) {
        const inRow = short[r] ? cols - 1 : cols;
        if (short[r]) { let w = i; for (let j = i + 1; j < i + inRow; j++) if (ar(tiles[j]) > ar(tiles[w]) + 0.05) w = j; wide.push(w); sum += ar(tiles[w]); }
        i += inRow;
      }
      if (!best || sum > best.sum + 0.05) best = { sum, wide };
    };
    // every way of choosing which rows are the short ones (a few rows at most)
    const choose = (r, left, acc) => {
      if (r === rows) { if (!left) pick(acc); return; }
      if (left) choose(r + 1, left - 1, acc.concat(true));
      if (rows - r > left) choose(r + 1, left, acc.concat(false));
    };
    choose(0, holes, []);
    best.wide.forEach((w) => tiles[w].classList.add('is-wide'));
    return 0;
  };
  // the deal photo: as big as the panel's own height allows (the card never makes the panel taller)
  const setDeal = (p) => {
    const deal = p.querySelector('.ceh-deal'), wrap = p.querySelector('.ceh-mega__in'), slot = p.querySelector('.ceh-mega__deal');
    if (!deal || !wrap || !slot) return;
    p.classList.add('is-measure'); p.style.setProperty('--dp', '0px');
    const cs = getComputedStyle(slot);
    const natural = deal.offsetHeight, rowH = wrap.offsetHeight - (parseFloat(cs.paddingTop) || 0) - (parseFloat(cs.paddingBottom) || 0);
    p.classList.remove('is-measure');
    p.style.setProperty('--dp', Math.max(96, Math.min(deal.clientWidth - 32, rowH - natural)) + 'px');
  };
  // brand logos that would be cut by the row's edge step out (never half a logo)
  const trimLogos = (p) => p.querySelectorAll('.ceh-brands__logos').forEach((row) => {
    const logos = [...row.querySelectorAll('.ceh-blogo')];
    logos.forEach((l) => l.classList.remove('is-off'));
    const right = row.getBoundingClientRect().right;
    logos.forEach((l) => { if (l.getBoundingClientRect().right > right + 0.5) l.classList.add('is-off'); });
  });
  // a short panel must not squeeze the deal photo: it grows while the panel still fits the screen and stays within
  // 70px of the panel's own height (a proper offer with a big photo, Tommy feedback 14; no tall empty band)
  const growDeal = (p) => {
    const deal = p.querySelector('.ceh-deal');
    if (!deal) return;
    const base = p.getBoundingClientRect().height, cap = Math.min(deal.clientWidth - 32, 210);
    let dp = parseFloat(p.style.getPropertyValue('--dp')) || 96;
    while (dp < cap) {
      const nd = Math.min(cap, dp + 8); p.style.setProperty('--dp', nd + 'px');
      if (over(p) > 0 || p.getBoundingClientRect().height > base + 70) { p.style.setProperty('--dp', dp + 'px'); break; }
      dp = nd;
    }
  };
  const fit = {};
  fit.rail = (p) => {
    const gp = p.querySelector('.ceh-gp.is-on') || p.querySelector('.ceh-gp:not([hidden])');
    if (!gp) return;
    const grid = gp.querySelector('.ceh-gp__grid'), n = grid.children.length;
    // fix round 10-10: a group of 2-4 ranges gets bigger photos in ONE row (it sat 2 x 2 or stacked, with 400-650px of
    // empty white beside it on big screens); popular brands stay: slimmer before they would ever go (Tommy 14)
    const slim = p.classList.contains('brands-slim');
    const max = n <= 2 ? 340 : n <= 4 ? 280 : (+p.dataset.max || 232), min = (+p.dataset.min || 84) - (slim ? 8 : 0);
    // the grid's real column gap (18px; 14px in a small panel) - the sums below used to assume 18 every time
    const gapOf = () => parseFloat(getComputedStyle(grid).columnGap) || 18;
    const dropBrands = () => {
      if (over(p) <= 0) return false;
      const k = !p.classList.contains('brands-slim') ? 'brands-slim' : !p.classList.contains('no-brands') ? 'no-brands' : '';
      if (!k) return false;
      p.classList.add(k); p.ceNb = true; fit.rail(p); p.ceNb = false; return true;
    };
    if (!n) {   // a group of text links only: the group list may still need to tighten
      if (!p.ceNb) p.classList.remove('no-brands', 'brands-slim');
      let rh0 = 46, rp0 = 7; setRail(p, rh0, rp0); p.style.setProperty('--dp', '96px');
      for (let k = 0; k < 12 && railOver(p) > 0; k++) { rh0 = Math.max(26, rh0 - 4); rp0 = Math.max(1, rp0 - 1); setRail(p, rh0, rp0); }
      setDeal(p);
      if (dropBrands()) return;
      growDeal(p); trimLogos(p); return;
    }
    let best = null;
    if (!p.ceAgain) p.classList.remove('is-small');
    if (!p.ceAgain && !p.ceNb) p.classList.remove('no-brands', 'brands-slim');
    setRail(p, 46, 7); p.style.setProperty('--dp', '96px'); grid.classList.remove('has-hero', 'is-few');
    p.style.setProperty('--t', min + 'px'); grid.style.setProperty('--cols', Math.min(Math.max(n, 1), 4));
    let rh = 46, rp = 7;
    for (let k = 0; k < 12 && railOver(p) > 0; k++) { rh = Math.max(26, rh - 4); rp = Math.max(1, rp - 1); setRail(p, rh, rp); }
    // layouts: the group's widest range as a big hero tile (odd counts), an even 2-row grid, or plain grids
    const cands = [];
    if (n >= 3 && n % 2 === 1) cands.push({ cols: (n - 1) / 2 + 2, hero: true, rows: 2 });
    if (n >= 4 && n % 2 === 0) cands.push({ cols: n / 2, hero: false, rows: 2 });
    // (fix round 10-10: up to 8 across, so a group of 7-8 ranges can sit in ONE row on a short laptop window instead of
    // two rows of tiny photos with half the panel empty)
    for (let cols = 1; cols <= Math.min(Math.max(n, 1), 8); cols++) cands.push({ cols, hero: false, rows: Math.ceil(n / cols) });
    const gap = gapOf();
    const tiles = [...grid.children];
    for (const c of cands) {
      grid.style.setProperty('--cols', c.cols); grid.classList.toggle('has-hero', c.hero);
      // (Tommy 10-10) a plain grid's short rows get a two-column tile; a slot that cannot be filled is a blank
      const blank = c.hero ? setWide(tiles, 1, 0) : setWide(tiles, c.cols, c.rows);
      let t = Math.min(max, Math.floor((grid.clientWidth - (c.cols - 1) * gap) / c.cols)); p.style.setProperty('--t', t + 'px');
      for (let k = 0; k < 12; k++) { const o = over(p); if (o <= 0) break; t = Math.max(min, Math.floor(t - o / Math.max(c.rows, 1)) - 1); p.style.setProperty('--t', t + 'px'); if (t === min) break; }
      const spill = spills(grid, '.ceh-tile__n');
      const holes = c.rows * c.cols - (c.hero ? n + 3 : n);
      // a layout that leaves the right of the panel empty reads unfinished (the small menus' rule, fix round 10-10)
      const empty = Math.max(0, 1 - (c.cols * t + (c.cols - 1) * gap) / Math.max(1, grid.clientWidth));
      const score = t * (c.rows > 2 ? 0.9 : 1) + (c.hero ? 30 : 0) - (holes - blank) * 12 - blank * 60 - empty * 120 - (over(p) > 0 ? 1000 : 0) - (spill ? 500 : 0);
      if (!best || score > best.score) best = Object.assign({}, c, { t, score, spill });
    }
    grid.style.setProperty('--cols', best.cols); grid.classList.toggle('has-hero', best.hero); p.style.setProperty('--t', best.t + 'px');
    if (best.hero) setWide(tiles, 1, 0); else setWide(tiles, best.cols, best.rows);
    if (best.t < 124 && !p.classList.contains('is-small')) { p.classList.add('is-small'); p.ceAgain = true; fit.rail(p); p.ceAgain = false; return; }
    // a name that would not fit its photo (a short window): a slimmer brand row gives the photos room first
    if (best.spill && !slim) { p.classList.add('brands-slim'); p.ceNb = true; fit.rail(p); p.ceNb = false; return; }
    setDeal(p);
    for (let k = 0; k < 10 && over(p) > 0; k++) { best.t = Math.max(min, best.t - Math.ceil(over(p) / 2)); p.style.setProperty('--t', best.t + 'px'); setDeal(p); }
    // the shortest windows: the brand row gets slimmer, and only then (never at the sizes checked) gives way
    // (build guide rule 9: extras may drop, never a category; Tommy 14: popular brands in every panel)
    if (dropBrands()) return;
    // a group of 2-3 ranges on a wide screen: wide feature cards across the whole row (the photo box keeps its height,
    // the product stays centred) instead of a few squares and a wall of white (fix round 10-10, critic: Specialty)
    const free = grid.clientWidth - (best.cols * best.t + (best.cols - 1) * gap);
    if (n <= 3 && best.rows === 1 && !best.hero && free > 60) grid.classList.add('is-few');
    growDeal(p);
    trimLogos(p);
  };
  // small menus: every group's photos at once (1, 2 or 3 rows a group), tiles as big as width and height allow
  fit.flat = (p) => {
    const area = p.querySelector('.ceh-fgs');
    if (!area) return;
    const groups = [...area.querySelectorAll('.ceh-fg')];
    const tl = groups.map((el) => [...el.querySelectorAll('.ceh-tile')]);
    const ns = tl.map((x) => x.length), big = Math.max(1, ...ns);
    const g = 16, G = 34, max = +p.dataset.max || 210, min0 = +p.dataset.min || 76;
    // every group fills all R rows (Tommy 10-10: no blank photo slots): its short rows get a two-column tile
    const shape = (ks, R) => groups.reduce((a, el, i) => { el.style.setProperty('--k', ks[i]); return a + setWide(tl[i], ks[i], R); }, 0);
    const run = () => {
      let best = null;
      const min = min0 - (p.classList.contains('brands-slim') ? 8 : 0);
      for (const R of [1, 2, 3]) {
        if (R > big) continue;
        const ks = ns.map((n) => Math.max(1, Math.ceil(n / R))), C = ks.reduce((a, b) => a + b, 0);
        const blank = shape(ks, R);
        let t = Math.min(max, Math.floor((area.clientWidth - (C - groups.length) * g - (groups.length - 1) * G) / C));
        const narrow = t < min;   // this many photos across cannot be big enough to read: never chosen
        p.style.setProperty('--t', t + 'px'); setDeal(p);
        for (let k = 0; k < 12; k++) { const o = over(p); if (o <= 0) break; t = Math.max(min, Math.floor(t - o / R) - 1); p.style.setProperty('--t', t + 'px'); setDeal(p); if (t === min) break; }
        const wide = ks.reduce((a, k, i) => a + k * R - ns[i], 0) - blank;
        const spill = spills(area, '.ceh-tile__n');
        // a layout that leaves the right of the panel empty reads unfinished: fill the width (Dishwashers = one row)
        const used = C * t + (C - groups.length) * g + (groups.length - 1) * G, empty = Math.max(0, 1 - used / area.clientWidth);
        const score = t - wide * 4 - blank * 60 - empty * 150 - (over(p) > 0 ? 1000 : 0) - (spill ? 500 : 0) - (narrow ? 2000 : 0);
        if (!best || score > best.score) best = { R, t, ks, score, ok: over(p) <= 0 && !spill && !narrow };
      }
      shape(best.ks, best.R); p.style.setProperty('--t', best.t + 'px'); setDeal(p);
      return best;
    };
    // short windows only: first the counts under the names go, then the brand row gets slimmer, then the title steps
    // out; the brand row itself goes only as a last resort (fix round 10-10, Tommy 14: popular brands in every panel)
    const levels = [[], ['is-tight'], ['is-tight', 'brands-slim'], ['is-tight', 'brands-slim', 'no-head'],
      ['is-tight', 'brands-slim', 'no-head', 'brands-inline'], ['is-tight', 'no-head', 'no-brands']];
    const cost = [0, 8, 12, 16, 20, 400];
    const apply = (lv) => { p.classList.remove('is-tight', 'no-brands', 'brands-slim', 'no-head', 'brands-inline'); lv.forEach((c) => p.classList.add(c)); };
    let pick = -1, alt = 0, top = -1e9;
    for (let i = 0; i < levels.length; i++) {
      apply(levels[i]); const b = run();
      if (b.ok && b.t >= 110) { pick = i; break; }
      if (b.score - cost[i] > top) { top = b.score - cost[i]; alt = i; }
    }
    if (pick < 0) { apply(levels[alt]); run(); }
    growDeal(p);
    trimLogos(p);
  };
  fit.all = (p) => {
    let ct = 156;
    const set = () => { p.style.setProperty('--ct', ct + 'px'); p.style.setProperty('--bt', Math.max(40, Math.min(52, Math.round(ct * 0.36))) + 'px'); p.style.setProperty('--btg', Math.max(44, Math.round(ct * 0.5)) + 'px'); };
    set();
    for (let k = 0; k < 20; k++) { const o = over(p); if (o <= 0) break; ct = Math.max(56, ct - Math.ceil(o / 1.5)); set(); if (ct === 56) break; }
  };
  fit.brands = (p) => {
    let lz = W.innerWidth >= 1800 ? 1.16 : 1;
    p.style.setProperty('--lz', lz);
    for (let k = 0; k < 12 && over(p) > 0 && lz > 0.62; k++) { lz = Math.round((lz - 0.06) * 100) / 100; p.style.setProperty('--lz', lz); }
  };
  const layout = (p) => { if (!p || !desk.matches) return; const f = fit[p.dataset.fit]; if (f) f(p); };

  /* ---------- 4. the deal card ---------- */
  // one product per card per page load, the next one each time (each menu's own card keeps its own turn); a product
  // whose last day has passed (data-ceh-until, a page served from cache) leaves first; an emptied card leaves too
  const pickDeal = (card) => {
    card.querySelectorAll('[data-ceh-until]').forEach((a) => { if (+a.dataset.cehUntil && +a.dataset.cehUntil < today) a.remove(); });
    const items = [...card.querySelectorAll('[data-ceh-deal]')];
    if (!items.length) { card.remove(); return; }
    const n = items.length, key = 'ce-deal-i' + (card.dataset.cehDealFor ? '-' + card.dataset.cehDealFor : '');
    let k = 0;
    try { k = (parseInt(W.localStorage.getItem(key) || '-1', 10) + 1) % n; W.localStorage.setItem(key, String(k)); }
    catch (e) { k = Math.floor(Math.random() * n); }
    if (!(k >= 0)) k = 0;
    items.forEach((a, j) => { if (j === k) a.hidden = false; else a.remove(); });
  };

  /* ---------- 2-8. the header ---------- */
  const bindHeader = (root) => {
    if (root.ceBound) return;
    root.ceBound = 1;
    const section = root.closest('.shopify-section') || root;
    const nav = root.querySelector('[data-ceh-nav]');
    const list = root.querySelector('[data-ceh-navlist]');
    const items = [...root.querySelectorAll('[data-ceh-item]')];
    const scrim = root.querySelector('[data-ceh-scrim]');
    const cart = root.querySelector('#cart-icon-bubble');
    let openItem = null, tOpen = 0, tClose = 0;
    dropExpired(root);
    root.querySelectorAll('[data-ceh-deal-card]').forEach(pickDeal);
    // the open menu's own deals card (Menu deal blocks, Tommy 10-10), else the "every other menu" one, else the general one
    const cardFor = (li) => root.querySelector(`[data-ceh-deal-card][data-ceh-deal-for="${li && li.dataset.cehItem}"]`)
      || root.querySelector('[data-ceh-deal-card][data-ceh-deal-for="any"]')
      || root.querySelector('[data-ceh-deal-card]:not([data-ceh-deal-for])');

    const measure = () => {
      const r = root.getBoundingClientRect();
      const nb = nav && desk.matches ? nav.getBoundingClientRect().bottom : r.bottom;
      root.style.setProperty('--ceh-bottom', Math.max(0, Math.round(nb)) + 'px');
      H.style.setProperty('--ce-header-h', Math.round(r.height) + 'px');
    };

    /* the nav row always fits one line: side padding first, then the text size (to 14px), never a link */
    const navFit = () => {
      if (!list) return;
      list.style.removeProperty('--np'); list.style.removeProperty('--nf');
      const link = list.querySelector('.ceh-nav__link');
      if (!desk.matches || !link) return;
      const last = list.lastElementChild;
      const overflow = () => last.getBoundingClientRect().right - (list.getBoundingClientRect().right - parseFloat(getComputedStyle(list).paddingRight));
      let np = parseFloat(getComputedStyle(link).paddingLeft), nf = parseFloat(getComputedStyle(link).fontSize);
      for (let k = 0; k < 40 && overflow() > 0.5; k++) {
        if (np > 7) np = Math.max(7, np - 1); else if (nf > 14) nf -= 0.5; else if (np > 4) np -= 1; else break;
        list.style.setProperty('--np', np + 'px'); list.style.setProperty('--nf', nf + 'px');
      }
    };

    /* scrolled shadow + hide on the way down, show on the way up */
    let lastY = W.scrollY, ticking = false;
    const smallHdr = W.matchMedia('(max-width: 1099px)');
    // keyboard focus inside the header keeps it on screen (a mouse click that leaves focus on a button does not)
    const kbFocus = () => { const a = D.activeElement; if (!a || a === D.body || !root.contains(a)) return false; try { return a.matches(':focus-visible'); } catch (e) { return true; } };
    const busy = () => !!openItem || root.classList.contains('is-help') || D.body.classList.contains('ce-drawer-open') || kbFocus();
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        const y = W.scrollY;
        root.classList.toggle('is-scrolled', y > 4);
        const b = busy();
        // Tommy 11-10 ("on mobile do you think the all categories nav menu should disappear quicker on scroll down?" +
        // "go"): phones and tablets (the chips header, < 1100px) - the category chips tuck away behind the navy bar as
        // soon as you scroll down (40px), the whole header goes at 120px (computers: 360px, as before); scrolling up
        // brings everything back. The header keeps its height in the page, so nothing below it jumps.
        const small = smallHdr.matches;
        const hideAt = small ? 120 : 360;
        if (!b && y > hideAt && y > lastY + 6) section.classList.add('ceh-hide');
        else if (y < lastY - 6 || y <= hideAt || b) section.classList.remove('ceh-hide');
        // (Tommy 11-10: "when you scroll back up on mobile ... maybe not until you scroll right back to the top": the chips
        // stay tucked on the way up too - logo + search come back, the chips only near the top of the page)
        if (small && !b && y > 40) section.classList.add('ceh-chipsoff');
        else if (!small || b || y <= 40) section.classList.remove('ceh-chipsoff');
        lastY = y;
        if (openItem) measure();
      });
    };

    /* ---- mega panels ---- */
    const panelOf = (li) => li.querySelector(':scope > .ceh-mega');
    const triggersOf = (li) => li.querySelectorAll(':scope > [data-ceh-toggle], :scope > .ceh-nav__all');
    const arm = () => { if (nav && !nav.classList.contains('is-armed')) nav.classList.add('is-armed'); };
    const close = (li, keep) => {
      if (!li) return;
      li.classList.remove('is-open');
      triggersOf(li).forEach((b) => b.setAttribute('aria-expanded', 'false'));
      if (openItem === li) openItem = null;
      if (!keep) { root.classList.remove('has-panel'); D.body.classList.remove('ceh-panel-open'); }
    };
    const closeAll = () => { clearTimeout(tOpen); clearTimeout(tClose); if (openItem) close(openItem); };
    const open = (li) => {
      clearTimeout(tClose);
      if (!desk.matches || openItem === li) return;
      const swap = !!openItem;
      if (swap) { nav.classList.add('is-swapping'); close(openItem, true); }
      const first = !nav.classList.contains('is-armed');
      arm();
      section.classList.remove('ceh-hide');
      const p = panelOf(li);
      measure();
      const go = () => {
        li.classList.add('is-open');
        triggersOf(li).forEach((b) => b.setAttribute('aria-expanded', 'true'));
        openItem = li;
        root.classList.add('has-panel');
        // the chat bubble and the quote app's View Quote tab step aside while a menu is open (they come back on close)
        D.body.classList.add('ceh-panel-open');
        if (p) {
          wake(p);
          const slot = p.querySelector('[data-ceh-deal-slot]');
          const card = cardFor(li);
          if (slot && card && card.parentNode !== slot) { slot.appendChild(card); wake(card); }
          layout(p);
        }
        if (swap) requestAnimationFrame(() => requestAnimationFrame(() => nav.classList.remove('is-swapping')));
      };
      if (first) { if (p) void p.offsetWidth; requestAnimationFrame(go); } else go();
    };
    const firstIn = (li) => { const p = panelOf(li); return p && p.querySelector('a[href], button:not([tabindex="-1"]), [role="tab"][tabindex="0"]'); };
    items.forEach((li) => {
      li.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'mouse' || !desk.matches) return;
        arm();
        clearTimeout(tClose); clearTimeout(tOpen);
        tOpen = setTimeout(() => open(li), openItem ? 70 : 140);
      });
      li.addEventListener('pointerleave', (e) => {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(tOpen);
        tClose = setTimeout(() => { if (openItem === li) close(li); }, 300);
      });
      triggersOf(li).forEach((btn) => btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (li.classList.contains('is-open')) close(li); else open(li);
      }));
      // keyboard: ArrowDown on the item opens its panel and moves into it
      li.querySelectorAll(':scope > .ceh-nav__link, :scope > .ceh-nav__all, :scope > [data-ceh-toggle]').forEach((t) => t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowDown') return;
        e.preventDefault();
        open(li);
        setTimeout(() => { const f = firstIn(li); if (f) f.focus(); }, 60);
      }));
      li.addEventListener('focusout', (e) => {
        if (openItem === li && (!e.relatedTarget || !li.contains(e.relatedTarget))) {
          setTimeout(() => { if (openItem === li && !li.contains(D.activeElement)) close(li); }, 0);
        }
      });
    });
    if (nav) { nav.addEventListener('pointerenter', arm); nav.addEventListener('focusin', arm); }
    if (scrim) {
      scrim.addEventListener('click', closeAll);
      scrim.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') { clearTimeout(tClose); tClose = setTimeout(closeAll, 120); } });
    }
    D.addEventListener('click', (e) => { if (openItem && !openItem.contains(e.target)) closeAll(); });

    /* the group list of a big menu: a tab list (pointing at a group, a click, or the arrow keys show its photos) */
    root.querySelectorAll('[data-ceh-rail]').forEach((tl) => {
      const p = tl.closest('.ceh-mega');
      const tabs = () => [...tl.querySelectorAll('[role="tab"]')];
      const select = (tab, focus) => {
        if (!tab || tab.classList.contains('is-on')) { if (focus && tab) tab.focus(); return; }
        tabs().forEach((t) => { const on = t === tab; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; });
        p.querySelectorAll('.ceh-gp').forEach((g) => { const on = g.id === tab.getAttribute('aria-controls'); g.classList.toggle('is-on', on); g.hidden = !on; });
        if (focus) tab.focus();
        layout(p);
      };
      if (!tl.querySelector('[role="tab"].is-on') && tabs()[0]) { const t0 = tabs()[0]; t0.classList.remove('is-on'); select(t0); }
      let tHover = 0;
      tabs().forEach((t) => {
        t.addEventListener('pointerenter', (e) => { if (e.pointerType !== 'mouse') return; clearTimeout(tHover); tHover = setTimeout(() => select(t), 60); });
        t.addEventListener('pointerleave', () => clearTimeout(tHover));
        t.addEventListener('click', () => select(t, true));
        t.addEventListener('keydown', (e) => {
          const all = tabs(), i = all.indexOf(t);
          let n = -1;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = (i + 1) % all.length;
          else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = (i - 1 + all.length) % all.length;
          else if (e.key === 'Home') n = 0;
          else if (e.key === 'End') n = all.length - 1;
          if (n < 0) return;
          e.preventDefault(); e.stopPropagation();
          select(all[n], true);
        });
      });
    });

    /* Brands A-Z (Tommy 10-10: "if you choose the letter should it show brands from the letter?"): the letters are tabs
       above the logos. A letter shows THAT letter's brands (logo + name) in place of the popular logos; "All" brings the
       popular logos back; a letter with no brand is dimmed and is not a tab. Click / tap, or the arrow keys, Home and
       End (the group list's tab rules); Tab moves on into the brands. A letter's logos load the first time it is picked.
       Every pane sits in the same grid cell (ce-header.css 9d), so the panel keeps one height whatever is picked. */
    root.querySelectorAll('[data-ceh-az]').forEach((az) => {
      const p = az.closest('.ceh-mega');
      const tabs = [...az.querySelectorAll('[role="tab"]')];
      const select = (tab, focus) => {
        tabs.forEach((t) => { const on = t === tab; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; });
        p.querySelectorAll('[data-az-list]').forEach((l) => {
          const on = l.id === tab.getAttribute('aria-controls');
          l.hidden = !on;
          if (on) l.querySelectorAll('img[data-az-src]').forEach((im) => { im.src = im.dataset.azSrc; im.removeAttribute('data-az-src'); });
        });
        if (focus) tab.focus();
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => select(t, false));
        t.addEventListener('keydown', (e) => {
          let n = -1;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % tabs.length;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') n = 0;
          else if (e.key === 'End') n = tabs.length - 1;
          if (n < 0) return;
          e.preventDefault(); e.stopPropagation();
          select(tabs[n], true);
        });
      });
    });

    /* ---- 5. search: "Search" + a rolling product word while the box is empty ---- */
    const form = root.querySelector('[data-ceh-search-form]');
    const input = form && form.querySelector('input[type="search"]');
    const field = form && form.querySelector('.ceh-search__field');
    const hintBox = form && form.querySelector('[data-ceh-hint]');
    if (input && hintBox) {
      const hints = (input.dataset.cehHints || '').split('|').map((h) => h.trim()).filter(Boolean);
      const hasText = () => field.classList.toggle('has-text', !!input.value);
      input.addEventListener('input', hasText);
      hasText();
      if (hints.length) {
        let k = 0;
        const prefix = input.dataset.cehPrefix || 'Search';
        hintBox.textContent = '';
        hintBox.append((input.dataset.cehPrefix || 'Search') + ' ');
        // Tommy 10-10: the hints lead with "commercial ..." ("Search commercial kitchen equipment..."). When the box is
        // too narrow for the longest of them (phones, a 1100px window), EVERY hint drops the word "commercial", so no
        // hint shows a cut-off word and they all read alike. Measured on a canvas: nothing is added to the page.
        const pen = D.createElement('canvas').getContext('2d');
        let short = false;
        const word = (t) => (short ? t.replace(/^commercial\s+/i, '') : t);
        const measure = () => {
          const room = hintBox.clientWidth;
          if (!pen || !room) return;
          const cs = getComputedStyle(hintBox);
          pen.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
          short = hints.some((t) => pen.measureText(prefix + ' ' + t + '…').width > room);
        };
        measure();
        // two word spans made ONCE; a roll only changes their words and classes. Fix round 10-10: a roll used to add
        // and remove an element every 2.6 s, and an element added anywhere makes the browser re-check the theme's
        // body:has(...) rules, which could restyle the WHOLE page (tools/fix_front_invalidation.mjs)
        const roll = D.createElement('span'); roll.className = 'ceh-search__roll';
        let cur = D.createElement('span'), nxt = D.createElement('span');
        cur.textContent = word(hints[0]); nxt.textContent = word(hints[1 % hints.length]); nxt.className = 'ceh-hold';
        roll.append(cur, nxt); hintBox.appendChild(roll); hintBox.append('…');
        field.classList.add('has-hint');
        const setPh = () => input.setAttribute('placeholder', prefix + ' ' + word(hints[k]) + '...');
        // the web font arriving, or the window changing size, can change the answer: re-measure, re-word what shows
        const rewordNow = () => {
          const was = short;
          measure();
          if (short === was) return;
          if (cur.firstChild) cur.firstChild.data = word(hints[k]); else cur.textContent = word(hints[k]);
          setPh();
        };
        if (D.fonts && D.fonts.ready) D.fonts.ready.then(rewordNow);
        let rewordQueued = 0;
        W.addEventListener('resize', () => { if (!rewordQueued) rewordQueued = requestAnimationFrame(() => { rewordQueued = 0; rewordNow(); }); });
        setPh();
        if (hints.length > 1 && !reduce.matches) {
          setInterval(() => {
            if (D.hidden || input.value || D.activeElement === input) return;
            k = (k + 1) % hints.length;
            if (nxt.firstChild) nxt.firstChild.data = word(hints[k]); else nxt.textContent = word(hints[k]);
            roll.style.width = Math.max(cur.offsetWidth, 10) + 'px';
            cur.className = 'ceh-out'; nxt.className = 'ceh-in';
            requestAnimationFrame(() => { roll.style.transition = 'width .42s cubic-bezier(.22,1,.36,1)'; roll.style.width = nxt.offsetWidth + 'px'; });
            setTimeout(() => {
              cur.className = 'ceh-hold'; nxt.className = '';
              roll.style.width = ''; roll.style.transition = '';
              const t = cur; cur = nxt; nxt = t;
              setPh();
            }, 460);
          }, 2600);
        }
      }
      // the chat bubble steps aside while the live results are open (ce-base.css .ceh-ps-open): a class on <html> set
      // here, not a body:has(predictive-search[open]) rule (fix round 10-10: that :has() made small changes restyle a lot)
      const pss = [...root.querySelectorAll('predictive-search')];
      if (pss.length && 'MutationObserver' in W) {
        const psSync = () => H.classList.toggle('ceh-ps-open', pss.some((p) => p.hasAttribute('open')));
        pss.forEach((p) => new MutationObserver(psSync).observe(p, { attributes: true, attributeFilter: ['open'] }));
      }
      form.addEventListener('submit', (e) => { if (!input.value.trim()) { e.preventDefault(); input.focus(); } });
      form.addEventListener('reset', () => setTimeout(() => field.classList.remove('has-text'), 0));
    }

    /* ---- 6. quote: the app's own count ---- */
    // 14-10-2026: Quotes AI replaces Omega (the app behind "Request a quote" beside Add to cart). Its launcher is
    // [data-qai-launcher] on <body> - hidden while the quote is empty, still clickable - with the count in
    // [data-qai-launcher-count], and its cart in localStorage qai_cart_v1:<shop> as {items:[{quantity}]}. Omega's
    // selectors stay as the fallback until it is uninstalled: whichever app is on the page wins, so this can go live
    // before the switch-over and nothing changes until Quotes AI's block is on the product page.
    const qa = root.querySelector('[data-ceh-quote]');
    if (qa) {
      const qn = qa.querySelector('[data-ceh-quote-n]'), qsr = qa.querySelector('[data-ceh-quote-sr]');
      const shop = () => (W.Shopify && W.Shopify.shop) || '';
      const key = () => shop() + '_productIdAddQuoteList';
      const qaiKey = () => 'qai_cart_v1:' + shop();
      const qaiBtn = () => D.querySelector('[data-qai-launcher]');
      const appBtn = () => qaiBtn() || D.querySelector('.omgrfq_view_quote_btn');
      const fromApp = () => {
        const b = appBtn(); if (!b) return null;
        const c = b.querySelector('[data-qai-launcher-count]');
        if (c) { const n = parseInt(c.textContent, 10); return isNaN(n) ? null : n; }
        const m = (b.textContent || '').match(/\((\d+)\)/); return m ? +m[1] : null;
      };
      const fromStore = () => {
        try {
          const c = JSON.parse(W.localStorage.getItem(qaiKey()) || 'null');
          if (c && Array.isArray(c.items)) return c.items.reduce((n, it) => n + Math.max(1, parseInt(it && it.quantity, 10) || 1), 0);
        } catch (e) { /* no Quotes AI cart yet */ }
        try { const v = JSON.parse(W.localStorage.getItem(key()) || '[]'); return Array.isArray(v) ? v.length : 0; } catch (e) { return 0; }
      };
      let last = -1, lifted = 0;
      // fix round 10-10: the app's floating tab shows only with products in the quote (ce-header.css html.ceh-quote-empty),
      // and on a short window it rises clear of the chat bubble (--ceh-qtab-lift: the overlap, measured, never guessed)
      const lift = () => {
        const b = appBtn(), chat = D.querySelector('body > button[style*="cm-pop"]');
        let up = 0;
        if (b && chat && last > 0 && desk.matches) {
          const r = b.getBoundingClientRect(), c = chat.getBoundingClientRect();
          if (r.height && c.height && r.right > c.left) up = Math.max(0, Math.ceil(r.bottom + lifted - (c.top - 14)));
        }
        if (up !== lifted) { lifted = up; H.style.setProperty('--ceh-qtab-lift', up + 'px'); }
      };
      const setQ = () => {
        const a = fromApp(), v = a === null ? fromStore() : a;
        if (v === last) return;
        const bump = last >= 0 && v > last;
        last = v;
        H.classList.toggle('ceh-quote-empty', v <= 0);
        if (qn) qn.textContent = v;
        qa.classList.toggle('has-items', v > 0);
        if (qsr) qsr.textContent = ', ' + v + ' ' + (qsr.dataset.word || '');
        if (bump && !reduce.matches) { qa.classList.remove('is-bump'); void qa.offsetWidth; qa.classList.add('is-bump'); }
        requestAnimationFrame(lift);
      };
      setQ();
      let ticks = 0;
      const tq = setInterval(() => { setQ(); lift(); if (++ticks > 12) { clearInterval(tq); setInterval(() => { if (!D.hidden) { setQ(); lift(); } }, 3000); } }, 1000);
      W.addEventListener('resize', () => requestAnimationFrame(lift), { passive: true });
      W.addEventListener('storage', setQ);
      D.addEventListener('click', () => { setTimeout(setQ, 700); setTimeout(setQ, 2200); }, true);
      // with products in the quote, the button opens the app's own quote window (as its View Quote tab does).
      // Quotes AI: always its window - empty, it says "Nothing in your quote yet, add a product" - because
      // /pages/request-for-quote was Omega's page and goes dark with it.
      qa.addEventListener('click', (e) => { const b = appBtn(); if (b && (last > 0 || qaiBtn())) { e.preventDefault(); b.click(); } });

      // Tommy 10-10 ("can you make the quote button animate in the header, to draw attention to it"): .is-call
      // (ce-header.css: a light runs round the edge, the sheet's lines write in) ~2.6 s after the page opens - three times
      // 9 s apart on the first page of a visit, once on later pages - but not while a menu or the drawer is open, the tab
      // is hidden or the mouse is on it. Hovering replays it. Once the button is used it stops for the rest of the visit.
      let callBusy = false, calls = 0, used = false, perPage = 3;
      try {
        used = !!sessionStorage.getItem('ce-quote-used');
        if (sessionStorage.getItem('ce-quote-called')) perPage = 1; else sessionStorage.setItem('ce-quote-called', '1');
      } catch (e) { /* private mode: the first-page plan every page */ }
      const call = () => {
        if (callBusy || reduce.matches) return false;
        callBusy = true;
        qa.classList.remove('is-call'); void qa.offsetWidth; qa.classList.add('is-call');
        setTimeout(() => { qa.classList.remove('is-call'); callBusy = false; }, 1700);
        return true;
      };
      const autoCall = () => {
        if (used || calls >= perPage) return;
        const busy = D.hidden || D.body.classList.contains('ceh-panel-open') || D.body.classList.contains('ce-drawer-open') || qa.matches(':hover');
        if (!busy && call()) calls++;
        if (calls < perPage) setTimeout(autoCall, busy ? 1500 : 9000);
      };
      if (!reduce.matches && !used) setTimeout(autoCall, 2600);
      qa.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') call(); });
      qa.addEventListener('click', () => { used = true; try { sessionStorage.setItem('ce-quote-used', '1'); } catch (e) { /* private mode */ } });
    }

    /* ---- 7. help menu ---- */
    root.querySelectorAll('[data-ceh-help]').forEach((h) => {
      const b = h.querySelector('.ceh-help__btn');
      const set = (on) => { h.classList.toggle('is-open', on); root.classList.toggle('is-help', on); b.setAttribute('aria-expanded', String(on)); };
      b.addEventListener('click', (e) => { e.stopPropagation(); set(!h.classList.contains('is-open')); });
      D.addEventListener('click', (e) => { if (!h.contains(e.target)) set(false); });
      h.addEventListener('keydown', (e) => { if (e.key === 'Escape' && h.classList.contains('is-open')) { e.stopPropagation(); set(false); b.focus(); } });
      h.addEventListener('focusout', (e) => { if (e.relatedTarget && !h.contains(e.relatedTarget)) set(false); });
      h.querySelectorAll('[data-ce-chat]').forEach((a) => a.addEventListener('click', () => setTimeout(() => set(false), 0)));
    });

    /* ---- 8. the phone drawer ---- */
    const drawer = root.querySelector('[data-ceh-drawer]');
    const burger = root.querySelector('[data-ceh-drawer-open]');
    let lastFocus = null;
    const focusables = () => [...drawer.querySelectorAll('a[href], button, input')].filter((x) => x.offsetParent !== null || x === D.activeElement);
    const levels = drawer ? [...drawer.querySelectorAll('[data-ced-level]')] : [];
    const svgUse = (id, sw) => `<svg class="ceh-ic" viewBox="0 0 24 24" aria-hidden="true" style="--sw:${sw}"><use href="#ceh-i-${id}"/></svg>`;
    const buildLevel = (lv) => {
      const body = lv.querySelector('[data-ced-body]');
      if (!body || body.dataset.built) return;
      const p = D.getElementById('CehMega-' + lv.dataset.cedLevel);
      body.dataset.built = '1';
      if (!p) return;
      const frag = D.createDocumentFragment();
      const addLinks = (sec, links) => {
        if (!links.length) return;
        const w = D.createElement('div'); w.className = 'ced-links';
        links.forEach((l) => {
          const a = D.createElement(l.tagName === 'A' ? 'a' : 'span');
          a.className = l.classList.contains('ceh-pill--g') ? 'ceh-pill--g' : 'ced-link';
          if (l.tagName === 'A') a.href = l.getAttribute('href');
          a.textContent = l.textContent;
          w.appendChild(a);
        });
        sec.appendChild(w);
      };
      p.querySelectorAll('[data-gl]').forEach((g) => {
        const sec = D.createElement('section'); sec.className = 'ced-g';
        const url = g.dataset.gu;
        const h = D.createElement(url ? 'a' : 'p'); h.className = 'ced-g__h';
        if (url) h.href = url;
        h.textContent = g.dataset.gl;
        if (url) h.insertAdjacentHTML('beforeend', svgUse('right', 2.2));
        sec.appendChild(h);
        const tiles = g.querySelectorAll('.ceh-tile');
        if (tiles.length) {
          const grid = D.createElement('div'); grid.className = 'ced-tiles';
          tiles.forEach((t) => {
            const a = D.createElement('a'); a.className = 'ced-tile'; a.href = t.getAttribute('href');
            const ph = t.querySelector('.ceh-ph'); if (ph) a.appendChild(ph.cloneNode(true));
            const n = D.createElement('span'); n.className = 'ceh-tile__n'; n.textContent = (t.querySelector('.ceh-tile__n') || t).textContent;
            a.appendChild(n); grid.appendChild(a);
          });
          sec.appendChild(grid);
        }
        // Tommy 10-10: the ice-shape chips (Ice Makers > By ice shape) come along as chips: the drawing + the name
        const chips = g.querySelectorAll('.ceh-ice__c');
        if (chips.length) {
          const w = D.createElement('div'); w.className = 'ced-ice';
          chips.forEach((c) => {
            const a = D.createElement('a'); a.className = 'ced-ice__c'; a.href = c.getAttribute('href');
            const d = c.querySelector('.ceh-ice__d'); if (d) a.appendChild(d.cloneNode(true));
            const n = D.createElement('span'); n.textContent = (c.querySelector('b') || c).textContent;
            a.appendChild(n); w.appendChild(a);
          });
          sec.appendChild(w);
        }
        addLinks(sec, [...g.querySelectorAll('.ceh-gp__links .ceh-pill')]);
        frag.appendChild(sec);
      });
      const more = p.querySelector('[data-gl-more]');
      if (more) {
        const sec = D.createElement('section'); sec.className = 'ced-g';
        const h = D.createElement('p'); h.className = 'ced-g__h'; h.textContent = (more.querySelector('.ceh-more__h') || {}).textContent || 'More';
        sec.appendChild(h);
        addLinks(sec, [...more.querySelectorAll('.ceh-pill')]);
        frag.appendChild(sec);
      }
      body.appendChild(frag);
    };
    // a level covers the menu's scroll box from its top: the list underneath is parked at the top (and stops scrolling)
    // while a level shows, and comes back where it was on the way back
    const scrollBox = drawer ? drawer.querySelector('[data-ced-scroll]') : null;
    let rootTop = 0;
    const showLevel = (k, focus) => {
      let shown = null;
      levels.forEach((lv) => { const on = lv.dataset.cedLevel === k; if (on) { buildLevel(lv); wake(lv); shown = lv; } lv.hidden = !on; });
      drawer.querySelectorAll('[data-ced-open]').forEach((b) => b.setAttribute('aria-expanded', String(b.dataset.cedOpen === k)));
      if (scrollBox) {
        if (shown) { if (!scrollBox.classList.contains('is-level')) rootTop = scrollBox.scrollTop; scrollBox.scrollTop = 0; scrollBox.classList.add('is-level'); }
        else if (scrollBox.classList.contains('is-level')) { scrollBox.classList.remove('is-level'); scrollBox.scrollTop = rootTop; }
      }
      if (shown) { shown.scrollTop = 0; if (focus) { const bk = shown.querySelector('[data-ced-back]'); if (bk) setTimeout(() => bk.focus({ preventScroll: true }), 40); } }
    };
    const openDrawer = (k) => {
      if (!drawer) return;
      lastFocus = D.activeElement;
      drawer.classList.add('is-armed');
      wake(drawer.querySelector('[data-ced-root]'));
      void drawer.offsetWidth;
      requestAnimationFrame(() => drawer.classList.add('is-open'));
      D.body.classList.add('ce-drawer-open');
      H.classList.add('ceh-locked');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      if (k) showLevel(k, true);
      else {
        showLevel('');
        const c = drawer.querySelector('.ced__close');
        setTimeout(() => { if (c) { try { c.focus({ preventScroll: true }); } catch (err) { c.focus(); } } }, 60);
      }
    };
    const closeDrawer = () => {
      if (!drawer || !drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      D.body.classList.remove('ce-drawer-open');
      H.classList.remove('ceh-locked');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (err) { /* old browser */ } }
    };
    if (burger) burger.addEventListener('click', () => openDrawer(''));
    if (drawer) {
      drawer.querySelectorAll('[data-ceh-drawer-close]').forEach((b) => b.addEventListener('click', closeDrawer));
      drawer.querySelectorAll('[data-ced-open]').forEach((b) => b.addEventListener('click', () => showLevel(b.dataset.cedOpen, true)));
      drawer.querySelectorAll('[data-ced-back]').forEach((b) => b.addEventListener('click', () => {
        const k = b.closest('[data-ced-level]').dataset.cedLevel;
        showLevel('');
        const c = drawer.querySelector(`[data-ced-open="${k}"]`);
        if (c) setTimeout(() => c.focus({ preventScroll: true }), 40);
      }));
      drawer.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab') return;
        const f = focusables();
        if (!f.length) return;
        const a = f[0], z = f[f.length - 1];
        if (e.shiftKey && D.activeElement === a) { e.preventDefault(); z.focus(); }
        else if (!e.shiftKey && D.activeElement === z) { e.preventDefault(); a.focus(); }
      });
      // the AI assistant: close the drawer first so the chat window is not hidden behind it
      drawer.querySelectorAll('[data-ce-chat]').forEach((a) => a.addEventListener('click', () => setTimeout(closeDrawer, 0)));
    }
    root.querySelectorAll('[data-ceh-chip]').forEach((c) => c.addEventListener('click', (e) => {
      if (desk.matches || !drawer) return;
      e.preventDefault();
      openDrawer(c.dataset.cehChip || '');
    }));

    D.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (openItem) {
        const li = openItem, inside = li.contains(D.activeElement);
        closeAll();
        // focus goes back to the item it came from (never lost in a closed panel)
        const t = li.querySelector(':scope > .ceh-nav__all') || li.querySelector(':scope > .ceh-nav__link');
        if (t && inside) t.focus();
      }
      if (drawer && drawer.classList.contains('is-open')) {
        const shown = levels.find((lv) => !lv.hidden);
        if (shown) { showLevel(''); const c = drawer.querySelector(`[data-ced-open="${shown.dataset.cedLevel}"]`); if (c) c.focus(); }
        else closeDrawer();
      }
    });
    desk.addEventListener('change', () => { closeAll(); closeDrawer(); measure(); navFit(); });

    /* cart bump after any cart change (ce-main.js fires ce:cart:updated for ours and Dawn's) */
    let bt = 0;
    D.addEventListener('ce:cart:updated', () => {
      if (!cart || reduce.matches) return;
      cart.classList.remove('is-bump'); void cart.offsetWidth; cart.classList.add('is-bump');
      clearTimeout(bt); bt = setTimeout(() => cart.classList.remove('is-bump'), 900);
    });

    W.addEventListener('scroll', onScroll, { passive: true });
    let rz = 0;
    W.addEventListener('resize', () => { cancelAnimationFrame(rz); rz = requestAnimationFrame(() => { measure(); navFit(); if (openItem) layout(panelOf(openItem)); }); }, { passive: true });
    measure(); navFit(); onScroll();
    if (D.fonts && D.fonts.ready) D.fonts.ready.then(() => { measure(); navFit(); });

    root.ceApi = { open, close, closeAll, openDrawer, closeDrawer, showLevel, layout, items, measure, navFit,
      openKey: (k) => { const li = root.querySelector(`[data-ceh-item="${k}"]`); if (li) open(li); return li; } };
  };

  /* ---------- 9. the logo entrance, its hover replay, and the family heart badge ---------- */
  const bindReplay = (a, svg) => {
    if (a.ceReplay) return;
    a.ceReplay = 1;
    let busyR = false;
    const go = () => {
      if (busyR || reduce.matches || !svg.classList.contains('is-done')) return;
      busyR = true;
      svg.classList.remove('is-replay'); void svg.getBoundingClientRect(); svg.classList.add('is-replay');
      setTimeout(() => { svg.classList.remove('is-replay'); busyR = false; }, 1300);
    };
    a.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') go(); });
    a.addEventListener('focus', go);
  };
  const playLogo = () => {
    const a = D.querySelector('[data-ceh-logo]');
    const svg = a && a.querySelector('.ce-logo--intro');
    const hdr = D.querySelector('[data-ceh]');
    const fam = D.querySelector('[data-ceh-fam]');
    const famMode = (hdr && hdr.dataset.badgePlay) || 'logo';
    let played = false;
    // Tommy 11-10: phones show the logo at once - no entrance (the inline script in ce-header.liquid never hides it there)
    if (svg && !reduce.matches && !mq('(max-width: 749px)').matches) {
      let seen = false;
      if (a.dataset.entrance === 'first') {
        try { seen = !!sessionStorage.getItem('ce-logo-seen'); sessionStorage.setItem('ce-logo-seen', '1'); } catch (e) { /* private mode */ }
      }
      if (seen) { svg.classList.add('is-done'); bindReplay(a, svg); }
      else {
        svg.classList.add('is-play'); played = true;
        setTimeout(() => { svg.classList.add('is-done'); bindReplay(a, svg); }, 2100);
      }
    } else if (svg) svg.classList.add('is-done');
    H.classList.remove('ce-logo-wait', 'ce-fam-wait');
    if (fam && !reduce.matches && !fam.ceDone && (famMode === 'every' || (famMode === 'logo' && played))) {
      fam.ceDone = 1;
      fam.classList.add('is-play');
      if (!played) fam.classList.add('is-now');
      setTimeout(() => fam.classList.remove('is-play', 'is-now'), 4300);
    }
  };
  const gate = () => {
    const ready = D.fonts && D.fonts.ready ? D.fonts.ready : Promise.resolve();
    Promise.race([ready, new Promise((r) => setTimeout(r, 1200))]).then(() => requestAnimationFrame(playLogo));
  };

  const api = W.CEHeader = {
    fit, over,
    init(root) {
      root = root || D;
      each(root, '[data-ceb]', bindBar);
      each(root, '[data-ceh]', bindHeader);
    }
  };
  const boot = () => { api.init(D); gate(); };
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
  W.addEventListener('load', () => W.dispatchEvent(new Event('resize')), { once: true });

  /* theme editor */
  D.addEventListener('shopify:section:load', (e) => { api.init(e.target); playLogo(); });
  D.addEventListener('shopify:block:select', (e) => {
    const t = e.target;
    const bar = t.closest && t.closest('[data-ceb]');
    if (bar && bar.ceShow) bar.ceShow(t);
  });
})();
